import { render, staticRenderFns } from "./DifferenceInMeans.vue?vue&type=template&id=95d88e2c&scoped=true&"
import script from "./DifferenceInMeans.vue?vue&type=script&lang=js&"
export * from "./DifferenceInMeans.vue?vue&type=script&lang=js&"
import style0 from "./DifferenceInMeans.vue?vue&type=style&index=0&id=95d88e2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d88e2c",
  null
  
)

export default component.exports